import { render, staticRenderFns } from "./eventTags.vue?vue&type=template&id=441fd629&scoped=true"
import script from "./eventTags.vue?vue&type=script&lang=js"
export * from "./eventTags.vue?vue&type=script&lang=js"
import style0 from "./eventTags.vue?vue&type=style&index=0&id=441fd629&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441fd629",
  null
  
)

export default component.exports